module.exports = __webpack_public_path__ + "static/media/title_coven.dc014ec4.svg";